import { useBackend } from "../../services";

export const useAddOriginCountry = () => {
  const { post } = useBackend();
  const addOriginCountry = (parameters: IAddOriginCountryParameters) =>
    post("originCountries", parameters);
  return { addOriginCountry };
};

export interface IAddOriginCountryParameters {
  name: string;
  countryIsoCode?: string;
}
